module.exports = __webpack_public_path__ + "img/htcm_12.bc19daae.jpg";